package org.hs_soft.runmynesto.domain.config

object Errors {

   const val timeoutErr: String = "Request Timeout"
}